<template>
  <div>
    <el-dialog
        :title="'Sửa icon'"
        :visible.sync="isUpdate"
        width="500px"
        :before-close="handleClose"
        top="5vh"
        @open="handleOpen"
        :close="handleClose"
    >
      <el-form
          :model="formData"
          :rules="rules" ref="formData"
          label-position="left"
          label-width="150px">
        <el-form-item label="Mã định danh" prop="idIcon">
          <el-input v-model="formData.idIcon" maxlength="8" show-word-limit disabled></el-input>
        </el-form-item>
        <el-form-item label="Tên" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="Key" prop="key">
          <el-input v-model="formData.key"></el-input>
        </el-form-item>
      </el-form>
      <div class="buttons">
        <el-button
            :loading="loading"
            size="small"
            type="success"
            style="margin-right: 10px"
            @click="handleUpload()"
        >
          Cập nhật
        </el-button>
        <el-button size="small" type="danger" @click="handleClose">
          <i class="el-icon-circle-close"/> Đóng
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import manageDataService from "@/services/AdminService/ManageDataService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "UpdateIconSystemDialog",
  data() {
    return {
      formData: {
        idIcon: "",
        name: "",
        key: "",
      },
      loading: false,
      rules: {
        idIcon: [
          {required: true, message: 'Ma định danh không được để trống', trigger: 'change'},
          {min: 8, max: 8, message: 'Yêu cầu 8 ký tự', trigger: 'blur'}
        ],
        name: [
          {required: true, message: 'Tên không được để trống', trigger: 'change'},
        ],
        key: [
          {required: true, message: 'Key không được để trống', trigger: 'change'},

        ],
      }
    }
  },
  props: {
    isUpdate: {
      type: Boolean,
      default: false
    },
    listIcon: {
      type: Array,
      default: () => []
    },
    icon: {
      type: Object,
      default: () => {}
    },
  },

  methods: {
    handleClose() {
      this.$refs['formData'].resetFields();
      this.$emit("close");
    },
    handleOpen(){
      this.formData.idIcon = this.$props.icon.idIcon;
      this.formData.name = this.$props.icon.name;
      this.formData.key = this.$props.icon.key;
    },
    handleUpload() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
            this.loading = true;
            manageDataService.updateIconSystem(this.formData).then((res) => {
              if (res.data.data) {
                NotifyMessage.leftCornerNotificationSuccess("Update icon thành công")
              } else {
                NotifyMessage.leftCornerNotificationError("Update icon thất bại")

              }
              this.loading = false;
              this.handleClose();
            }).catch((err) => {
              this.loading = false;
              NotifyMessage.leftCornerNotificationError(err.response.data.message)
            })
        }
      });
    },

  }

}
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  justify-content: right;
  text-align: right;
  margin-top: 10px;
}
</style>